import { DEV } from 'solid-js'
import type { Entity } from '../entity/index'
import type { EntityGridXYV2 } from './EntityGridXYV2.type'

export default function createEntityGridXYV2(
  ents: Array<Entity>,
  gridWidth: number,
  gridHeight: number
): EntityGridXYV2 {
  // console.log('entityListToGridXY')
  // Initialize the grid as an empty array
  // const grid: EntityGridXY = []
  const len = gridWidth * gridHeight
  const grid = Array(len)
  for (let index = 0; index < len; index++) {
    grid[index] = []
  }

  for (let entIndex = 0; entIndex < ents.length; entIndex++) {
    const entity = ents[entIndex]
    const { x, y } = entity

    if (DEV) {
      // Validate coordinates are within grid bounds
      if (x < 0 || x >= gridWidth || y < 0 || y >= gridHeight) {
        throw new Error(
          `Entity ${entity.id} has invalid coordinates (${x}, ${y}) ` +
          `outside grid bounds (${gridWidth}x${gridHeight})`
        )
      }
    }
    
    const gridIndex = x + (y * gridWidth)
    grid[gridIndex].push(entity)
  }

  return grid
}
